import { Cols } from './cols.class';
import { AbstractTable } from '../context/abstract/table.class';

export class ColReseter<D extends object> {
   public dataForDom: Array<{ title: string; func: () => void }>;

   constructor(
      private ctx: AbstractTable<D>,
      private cols: Cols<D>,
   ) {
      this.dataForDom = [
         { title: 'Visibility', func: () => this.visibility() },
         { title: 'Sorting', func: () => this.sorting() },
         { title: 'Order', func: () => this.order() },
         { title: 'Sizes', func: () => this.sizes() },
         // { title: 'Filter', func: () => this.filter() },
      ];
   }

   public all() {
      this.sorting();
      this.sizes();
      this.visibility();
      this.order();
      // this.filter();
   }

   public sizes() {
      this.cols.all.forEach($col => {
         $col.width["width.%"] = $col.defaults["width.%"];
         $col.width["min-width.px"] = $col.defaults["min-width.px"];
      });
      this.ctx.dom.wrapper.scrollTo({ left: 0 });
   }
  
   public order() {
      this.cols.all.forEach($col => {
         $col.order = $col.defaults.order;
      });
      this.organize();
   }

   public visibility() {
      this.cols.all.forEach($col => {
         $col.isVisible = $col.defaults.isVisible;
      });
      this.organize();
   }

   public sorting() {
      this.ctx.sorter.sortByDefault();
   }

   public organize() {
      this.cols.visible = this.cols.all.filter(col => col.isVisible);
      this.cols.visible.sort((a, b) => a.order - b.order);
      this.cols.visible.forEach((col, ind) => col.order = ind);
      this.cols.draggable = this.cols.visible.filter(col => !col.isPinned);
      this.cols.pinned = this.cols.visible.filter(col => col.isPinned);
      this.cols.lastPinned = this.cols.pinned[this.cols.pinned.length - 1];
      this.cols.all.forEach(col => { 
         if (!col.isVisible) {
            col.order = col.isPinned ? null : Infinity;
         }
      });
   }

   // public filter() {
   //    this.ctx.filter.clear();
   // }
}
